export const RECLAIM_ACCOUNT = 'RECLAIM_ACCOUNT';
export const CLAIM_FORM = 'CLAIM_FORM';
export const MANUAL_ENTRY_FORM = 'MANUAL_ENTRY_FORM';
export const CLAIMED_COMPLETED = 'CLAIMED_COMPLETED';
export const EMAIL_MISMATCH = 'EMAIL_MISMATCH';
export const BOOKING_NOT_FOUND = 'BOOKING_NOT_FOUND';
export const DETAILS_MANUAL_ENTRY_FORM = 'DETAILS_MANUAL_ENTRY_FORM';
export const SELF_SERVE_ARRAY = 'SELF_SERVE_ARRAY';
export const CLAIMED = 'CLAIMED';
export const IMPORT_IN_PROGRESS = 'IMPORT_IN_PROGRESS';
export const IMPORT_ERROR = 'IMPORT_ERROR';
export const UPDATE_DOB = 'UPDATE_DOB';
export const READY_TO_CLAIM = 'READY_TO_CLAIM';
